import React from 'react';

import { getCroppedImageUrl } from '@weee-fe/module';

import Description from './description';
import Icon from './icon';
import SubTitle from './sub-title';
import Title from './title';

import type { FeatureHeaderProperties } from './index';
interface LayoutStackProps {
  className?: string;
  properties: FeatureHeaderProperties;
}

const LayoutStack: React.FC<LayoutStackProps> = ({ properties }) => {
  const { mobile_media } = properties;

  return (
    <div
      className="w-full flex items-end justify-between pt-[140px] relative overflow-hidden"
      data-testid="mod-featured-header-layout-stack">
      {/* 背景图片层 */}
      {mobile_media && (
        <div
          className="absolute top-0 right-0 h-auto bg-[#ffffff] bg-no-repeat bg-cover"
          style={{
            width: '100%',
            aspectRatio: '390 / 219',
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${getCroppedImageUrl(
              mobile_media,
              {
                renderWidth: 500
              }
            )})`
          }}
        />
      )}
      {/* 内容层 */}
      <div className="w-full relative z-10 pl-10 pr-5 pt-5 mr-5 bg-[#ffffff] rounded-tr-700">
        <SubTitle properties={properties} />
        <Title properties={properties} className="my-3" />
        <Description properties={properties} />
      </div>
      {/* 图标层*/}
      <Icon properties={properties} wrapperClassName="absolute top-[60px] left-10 z-10" />
    </div>
  );
};

export default LayoutStack;
